import { useScriptMetaPixel, useScriptGoogleTagManager, useScript, defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const googleTagManager = useScriptGoogleTagManager({"id":"GTM-PT7R2LMZ","async":true,"defer":true})
    const metaPixel = useScriptMetaPixel({"id":"607373963219967","async":true,"defer":true})
    return { provide: { $scripts: { googleTagManager, metaPixel } } }
  }
})